import React, { useEffect, useRef } from 'react'
import clsx from 'clsx'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import FullEditor from 'ckeditor5-build-full'

import { configuration } from './editorConfiguration'

// import { uploadSingleFile } from '../../../api/files'
// import { SERVER_URL } from '../../../api'

import './editor.css'

function Editor({ body, setBody, placeholder = '', /* folder = 'unclassified', */ disabled = false, className, lang = 'en' }) {
	const editorRef = useRef(null)
	const mountedRef = useRef(true)
	const readyRef = useRef(false)
	const initialBodyRef = useRef(body || '')

	useEffect(() => () => {
		mountedRef.current = false
		readyRef.current = false
		editorRef.current = null
	}, [])

	useEffect(() => {
		const editor = editorRef.current
		const content = body || ''

		// CKEditor only uses its data prop during initialization. Keep it in sync
		// when a template is loaded asynchronously, without resetting user input.
		if (editor && editor.state !== 'destroyed' && editor.getData() !== content) {
			editor.setData(content)
		}
	}, [body])

	// function uploadAdapter(loader) {
	// 	return {
	// 		upload: () => {
	// 			return new Promise((resolve, reject) => {
	// 				loader.file
	// 					.then((file) => {
	// 						uploadSingleFile(file/* , folder */)
	// 							.then((res) => {
	// 								resolve({
	// 									default: `${SERVER_URL}/${res.data.fileURL}`
	// 								})
	// 							})
	// 					})
	// 					.catch(error => reject(new Error(error || 'Could not upload image')))
	// 			})
	// 		}
	// 	}
	// }
	// function uploadPlugin(editor) {
	// 	editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
	// 		return uploadAdapter(loader)
	// 	}
	// }

	return (
		<div className={clsx('custom-editor', className)}>
			<CKEditor
				editor={ FullEditor }
				config={{ placeholder, ...configuration, language: lang }}
				// config = {{ extraPlugins: [uploadPlugin], ...configuration }}
				data={body || ''}
				onReady={ editor => {
					if (!mountedRef.current || !editor || editor.state === 'destroyed') return
					editorRef.current = editor
					const content = body || ''
					if (content !== initialBodyRef.current && editor.getData() !== content) {
						editor.setData(content)
					}
					readyRef.current = true
				} }
				onChange={ ( event, editor ) => {
					if (!mountedRef.current || !readyRef.current || !editor) return
					const data = editor.getData()
					setBody(data)
				} }
				disabled={disabled}
			/>
		</div>
	)

}

export default Editor
